// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-c462feb2]{display:none}.wrapper__tabs[data-v-c462feb2]{border:1px solid rgba(29,31,34,.05);border-radius:8px;padding:16px}.wrapper__title[data-v-c462feb2]{color:var(--c-black-primary);letter-spacing:-.5px}.wrapper__catchphrase[data-v-c462feb2]{color:var(--c-grey-600);font-size:16px;letter-spacing:-.25px;line-height:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
